module.exports = __webpack_public_path__ + "static/divider-04b2df0d48fe6f16a715b1c1dc282d70.png";